// AMB-717 — pure helpers: match an Agents client card to its Launch OS link, and label it.
export interface ClientLink {
  id: string;
  clientSlug?: string | null;
  clientName?: string | null;
  createdAt?: string;
}

export const linkForClient = (links: ClientLink[], client: { slug?: string; name: string }) =>
  links.find((l) => client.slug && l.clientSlug === client.slug) ||
  links.find((l) => !l.clientSlug && l.clientName && l.clientName.trim().toLowerCase() === client.name.trim().toLowerCase());

export const linkedLabel = (link: ClientLink) => {
  if (!link.createdAt) return "Linked";
  const d = new Date(link.createdAt);
  return `Linked · ${d.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" })}`;
};

